import { Button, Text } from '@chakra-ui/react';
import { LPTokenIcon } from '@ui/components/LPTokenIcon';
import {
  ModalOrDrawerBody,
  ModalOrDrawerFooter,
} from '@ui/components/ModalOrDrawer';
import { useTranslations } from '@ui/i18n';
import { formatTokenAmount } from '@ui/utils/format';
import { gardenTokenDict } from '@ui/utils/garden';

import { useGardenModalStore } from '../useGardenModalStore';
import { useGardenPlantDrawer } from './useGardenPlantDrawer';

export const SuccessContent = () => {
  const t = useTranslations();
  const coinMode = useGardenPlantDrawer((s) => s.coinMode);
  const setGardenModalActiveView = useGardenModalStore((s) => s.setActiveView);
  const isWithdraw = useGardenPlantDrawer((s) => s.isWithdraw);
  const onClose = useGardenPlantDrawer((s) => s.onClose);
  const gardenType = useGardenPlantDrawer((s) => s.gardenType);
  const tLcroPlantAmount = useGardenPlantDrawer((s) => s.tLcroPlantAmount);

  return (
    <>
      <ModalOrDrawerBody alignItems="center">
        <Text textStyle="h3" textAlign="center">
          {t('Transaction completed!')}
        </Text>
        <Text mt="24px" textStyle="bodySmall" textAlign="center">
          {isWithdraw
            ? t('You have withdrawn')
            : t('You have successfully planted')}
        </Text>
        <LPTokenIcon
          coinMode={coinMode}
          gardenType={gardenType}
          mx="auto"
          textStyle="h2"
          textAlign="center"
          iconWidth="40px"
          iconHeight="40px"
          justify="center"
        >
          {formatTokenAmount(
            tLcroPlantAmount,
            4,
            gardenTokenDict[coinMode][gardenType].decimals,
          )}
        </LPTokenIcon>
        <Text hidden={isWithdraw} textAlign="center" mt="24px">
          {t(
            'Grow your Garden by watering and employing helpers to increase your harvest, earning you more rewards',
          )}
        </Text>
      </ModalOrDrawerBody>
      <ModalOrDrawerFooter>
        <Button
          className="veno-tour__plant-modal-grow-button"
          hidden={isWithdraw}
          onClick={() => {
            onClose();
            setGardenModalActiveView('GROW_WATER');
          }}
        >
          {t('Grow your Garden')}
        </Button>
        <Button
          mt={2.5}
          variant={isWithdraw ? 'primary' : 'link'}
          onClick={onClose}
        >
          {t('Done')}
        </Button>
      </ModalOrDrawerFooter>
    </>
  );
};
